import * as swcHelpers from '@swc/helpers';

/**
 * Merges two ComposedFormValueState objects. When a field occurs in the same
 * part in both composed states, the field's state from `b` is used.
 */ const mergeComposedFormValueState = (a, b)=>Object.entries(b).reduce((result, [partKey, partState])=>swcHelpers.objectSpread({}, result, {
            [partKey]: swcHelpers.objectSpread({}, result[partKey], partState)
        })
    , swcHelpers.objectSpread({}, a))
;

export { mergeComposedFormValueState };
//# sourceMappingURL=merge-composed-form-value-state.js.map
